import { Field, Model, CodeModel, FIELD_TYPES } from "@/vue-ocom/schema";

export default Model("form_entry", {
  verbose_name: "Form Entry",
  verbose_name_plural: "Form Entries",
  fields: [
    Field("id", {
      label: "ID",
      primary_key: true,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.AutoNumber,
    }),

    Field("created_date", {
      label: "Created Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("modified_date", {
      label: "Modified Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("created_user", {
      label: "Created User",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "auth.User",
      ref_display_field: "username",
      default: () => {
        return null;
      },
    }),
    Field("modified_user", {
      label: "Modfied User",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "auth.User",
      ref_display_field: "username",
      default: () => {
        return null;
      },
    }),

    Field("created_user__username", {
      label: "Created User",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),

    Field("sign_offs", {
      label: "Sign Offs",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.ManyToMany,
      ref_field_type: "FormEntrySignOff",
      default: () => {
        return [];
      },
    }),
    Field("form_template_version", {
      label: "Form Template Version",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "FormTemplateVersion",
      ref_display_field: "name",
      default: () => {
        return null;
      },
    }),
    Field(
      "form_template_version__form_template_versions__form_template__name",
      {
        label: "Form Template Name",
        primary_key: false,
        readonly: true,
        required: false,
        hide: false,
        field_type: FIELD_TYPES.String,
        default: () => {
          return null;
        },
      }
    ),

    Field("uuid", {
      label: "UUID",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.UUID,
      default: () => {
        return null;
      },
    }),
    Field("data", {
      label: "Data",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Json,
      default: () => {
        return {};
      },
    }),
    Field("other_id", {
      label: "Other ID",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return null;
      },
    }),
    Field("other_name", {
      label: "Other Name",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return "";
      },
    }),
    Field("submitted_user", {
      label: "Submitted User",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "auth.User",
      ref_display_field: "username",
      default: () => {
        return null;
      },
    }),
    Field("submitted_user__username", {
      label: "Submitted User",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),

    Field("sign_off_done", {
      label: "Sign Off Done",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Boolean,
      default: () => {
        return false;
      },
    }),
    Field("files", {
      label: "Files",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.ManyToMany,
      ref_field_type: "FormEntryFile",
      default: () => {
        return [];
      },
    }),
    Field("submitted_date", {
      label: "Submitted Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.DateTime,
      default: () => {
        return null;
      },
    }),
    Field("tags", {
      label: "Tags",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Array,
      default: () => {
        return [];
      },
    }),
    Field("score", {
      label: "Score",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Json,
      default: () => {
        return {};
      },
    }),
    Field("is_locked", {
      label: "Is Locked",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Boolean,
      default: () => {
        return false;
      },
    }),
    Field("workflow_status", {
      label: "Workflow Status",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return "";
      },
    }),
    Field("modified_user", {
      label: "Modified User",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "User",
      ref_display_field: "username",
      default: () => {
        return null;
      },
    }),
    Field("modified_user__username", {
      label: "Modified User",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),
  ],
});
